<template>
	<div>
		<navTitle><div class="pageTitle">名师主页</div></navTitle>
    <div class="content">
      <div class="top">
        <div class="avatar">
          <img :src="detail.avatar" mode="">
        </div>
        <div class="name">{{detail.truename}}</div>
        <div class="info">擅长{{goodAt}}，毕业于{{detail.graduation_school}}，从业{{year}}年，于{{vip_apply_time}}入会</div>
      </div>
      <div class="homtTitle flex flex-align-center">
        <div class="left">教学成果</div>
      </div>
      <div class="text"  v-html="detail.teaching_achievements">

      </div>
      <div class="homtTitle flex flex-align-center">
        <div class="left">相关奖状或证书</div>
      </div>
      <div class="imgs">
        <img @click="openImg(index)" v-for="(item,index) in detail.certificates" :key="index" class="img" :src="item">
      </div>

      <div v-if="videoList.length" class="homtTitle flex flex-align-center">
        <div class="left">学员风采</div>
      </div>
			<div class="videoList flex flex-align-center flex-jus-between flex-wrap">
				<div class="videoItem" v-for="item in videoList" :key="item.id">
					<videoItem :cover="item.pic ? item.pic : item.video + '?vframe/jpg/offset/0'" type="1" :width="167" :height="111" :is_link="item.is_link" :id="item.id" :videoSrc="item.video" :content="item.title"></videoItem>
				</div>
			</div>
    </div>
    <van-image-preview v-model="showImg" :images="imagesArr" :startPosition="startPosition">
    </van-image-preview>
	</div>
</template>

<script>
/* eslint-disable */
import videoItem from '@/views/components/videoItem.vue';
export default {
  components: {
    videoItem
  },
	data() {
		return {
      id: '',
      detail: {},
      goodAt: '',
      year: '',
      vip_apply_time: '',
      showImg: false,
			imagesArr: [],
      startPosition: 0,
      videoList: [],
      testText:'2222<</br>33333'

		};
	},

	created() {
    this.id = this.$route.query.id
    this.getData()
    this.getVideo()
  },
	mounted() {

  },
	methods: {
    getData() {
      this.$get('api/user/getUserAuthenticationDetails', {
        user_authentication_id: this.id
      }).then(res => {
        this.detail = res.data
        this.goodAt = this.detail.major_names.join('、')
        this.year = new Date().getFullYear() - new Date(this.detail.employment_time).getFullYear()
        this.vip_apply_time = this.detail.vip_apply_time.split(' ')[0]
        this.$wx.ready(() => {
          this.$wx.updateAppMessageShareData({
            title: '福建省民族管弦乐学会',
            desc: '认证名师 ' + this.detail.truename,
            link: location.href,
            imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
          })
          this.$wx.updateTimelineShareData({
            title: '福建省民族管弦乐学会',
            link: location.href,
            imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
          })
        });
      })
    },
    getVideo() {
      this.$get('api/user/getUserAuthenticationVideo', {
        user_authentication_id: this.id
      }).then(res => {
        this.videoList = res.data
      })
    },
    openImg(index) {
      this.startPosition = index
      this.imagesArr = this.detail.certificates
      this.showImg = true
    }
	}
};
</script>

<style lang="stylus" scoped>
.content {
  padding 88px 30px
}
.top {
  width 690px
  height 230px
  background url('~@/static/images/index/teacherTopBg.png')
  background-size 100%
  position relative
  background-color #F6F3F1
  padding-top 88px
}
.avatar {
  background-color #fff
  position absolute
  left 50%
  transform translateX(-50%)
  width 172px
  height 172px
  background url('~@/static/images/index/teacherAvatar.png')
  background-size 100% 100%
  top -86px
  // padding 16px
}
.avatar img {
  width 132px
  height 132px
  border-radius 50%
  position absolute
  top 50%
  left 50%
  transform translate(-50%, -50%)
}
.name {
  margin-bottom 12px
  font-size 32px
  line-height 34px
  color #000
  text-align center
  font-weight bold
}
.info {
  text-align center
  font-size 24px
  color #7B6E5F
  max-width 560px
  margin 0 auto
}
.homtTitle
		margin-top 40px
		width 100%
		height 70px
		background-image url('~@/static/images/index/titleBG.png')
		background-size 100px 70px
		background-position left
		background-repeat no-repeat
		.left
			margin-left 25px
			font-size: 36px;
			font-weight: 800;
			color: #151925;
.text
  font-size 26px
  color #333
  line-height 32px
  margin-top 28px

.imgs
  display flex
  flex-wrap wrap
  justify-content space-between
  margin-top 36px
  .img
    width 220px
    height 220px
    margin-bottom 24px
    border-radius 24px
    overflow hidden
    object-fit cover
.imgs:after
  display inline-block
  width 220px
  content ''
</style>
